<div class="report-query-container">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'report-query.title' | translate }}</h2>
    <div class="page-subtitle-block">
      <img
        width="26"
        height="26"
        ngSrc="assets/img/i-clock-user.svg"
        alt="clock-user"
      />
      <p>{{ 'report-query.hint' | translate }}</p>
    </div>
  </div>

  <div class="report-table-block">
    <div class="report-table">
      <!-- table-header 表頭-->
      <div class="report-table-header">
        <span>{{ 'report-query.exam-date' | translate }}</span>
        <span>{{ 'report-query.report-status' | translate }}</span>
      </div>
      <div class="report-table-body">
        @for (report of reportList | paginate: config; track $index) {
          <div class="report-table-list">
            <span class="report-table-list-date">{{
              report.bookDate | twDate
            }}</span>
            @if ((report.bookStatus === '8' || report.bookStatus === '9') && report.caseNo) {
              <!--TODO 確認bookStatus-->
              <button
                mat-button
                (click)="downloadReport(report.caseNo)"
                class="btn-icon"
              >
                <img
                  ngSrc="assets/img/i-download.svg"
                  width="24"
                  height="24"
                  alt=""
                />
              </button>
            } @else {
              <span class="report-table-list-status">{{
                'report-query.report-not-ready' | translate
              }}</span>
            }
          </div>
        }
      </div>
    </div>
    <pagination-controls
      [id]="config.id || 'report-pagination'"
      [maxSize]="maxSize"
      [directionLinks]="directionLinks"
      [autoHide]="autoHide"
      [responsive]="responsive"
      [previousLabel]="labels.previousLabel"
      [nextLabel]="labels.nextLabel"
      (pageChange)="onPageChange($event)"
      (pageBoundsCorrection)="onPageBoundsCorrection($event)"
    ></pagination-controls>
  </div>
</div>
